export class RecordingMatchModel {
    ActuacionId: number;
    GrabacionId: number;
    TrabajadorId: number;
    BajaId: number;
}

export class Recording {
    grabacionId: number;
    fecha: string;
    telefono: string;
    duracion: number;
    ficheroOriginal: string;
    grabacion: string;
    actuacionId: number;
    bajaId: number;
    trabajadorId: number;
    llamadaTrabajador: string;
    eliminada: string;

    isMatching: boolean;
    isPlaying: boolean;
    duration: string;

    public constructor(init?:Partial<Recording>) {
        Object.assign(this, init);
        this.isMatching = false;
        this.isPlaying = false;

        const date = new Date(0);
        date.setSeconds(this.duracion);
        this.duration = date.toISOString().substr(11, 8);
    }
}

export enum AudioStatus {
    Stop = 0,
    Play = 1
}